<template>
    <div class="">
        <a class="search" @click.prevent="opened = !opened;" href="#"><img src="/local/templates/master-om/img/search.svg"/></a>
        <form class="search-form" :class="{ 'js__active' : opened, }" autocomplete="off" action="/catalog/" method="get" >
            <div class="search-close" @click.prevent="opened = !opened;" ></div>
            <div class="search-input">
                <input v-model="q" class="search-input__control" name="q" type="text" placeholder="Поиск"/>
                <input style="display : none;" type="submit" value="Найти"/>
            </div>
            <div v-if="items.length" class="search-results">
                <div class="search-results__list">
                    <div v-for="item in items" :key="item.id" class="search-results__item" >
                        <div class="search-results__item-pic">
                            <img v-if="item.picSrc" :src="item.picSrc" />
                        </div>
                        <div class="search-results__item-info">
                            <div class="search-results__item-name">
                                <a :href="item.url" >{{ item.name }}</a>
                            </div>
                            <div class="search-results__item-price">
                                {{ item.price | priceFormat }}&nbsp;руб.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="search-results__footer">
                    <button type="submit" class="btn btn--header-search-more" >Посмотреть все результаты</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name : 'HeaderSearch',
    props : {
        delay : {
            type : Number,
            default : 1500,
        },
    },
    data : () => ({
        q : '',
        opened : false,
        results : [],
    }),
    mounted(){
        /**
         * Закрытие поиска по клику вне его
         */
        document.body.addEventListener("click", (event) => {
            const target = event.target,
                headerSearch = document.querySelector(".header-search"),
                searchForm = document.querySelector(".header-top .search-form");

            if (!headerSearch || !searchForm) return;

            if (
                !target.classList.contains("header-search")
                && !headerSearch.contains(target)
            ){
                this.opened = false;
                // searchForm.classList.remove("js__active");
            }
        });
    },
    computed : {
        items () {
            if (!this.q) {
                return [];
            }
            let res = this.results.find(r => r.q == this.q);
            if (res) {
                return res.items || [];
            }
            return [];
        },
    },
    watch : {
        q (q) {
            clearTimeout(this.searchTimeout);
            if (q && !this.results.find(r => r.q == q)) {
                this.searchTimeout = setTimeout(()=>{
                    this.search();
                }, (+this.delay || 1500));
            }
        },
    },
    methods : {
        search () {
            if (!this.q) {
                return;
            }
            fetch(`/api/v1/search/?q=${this.q}`)
                .then(res => res.json())
                .then(res => {
                    let items = [];
                    if (res.items) {
                        items = res.items;
                    }
                    this.results.push({
                        q : this.q,
                        items,
                    });
                });
        },
    },
}
</script>
